"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpolate = void 0;
var PARAMS_PATTERN = /{(.*?)}/g;

var interpolate = function interpolate(key, params) {
  if (key && params && params.length && PARAMS_PATTERN.test(key)) {
    var replacer = function replacer(match, key) {
      return params[key];
    };

    return key.replace(PARAMS_PATTERN, replacer);
  }

  return key;
};

exports.interpolate = interpolate;